import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const ImgTextButton = ({ blok }) => (
  <div className="">
    <div className={`imgtextbutton-wrap ${blok.reverse ? 'reverse' : ''}`} {...storyblokEditable(blok)}>
      <div className="imgtextbutton-contentLeft">
        <img
          className="imgtextleft-image"
          src={blok.image.filename}
          alt={blok.image.alt}
        />
      </div>

      <div className="imgtextbutton-contentRight">
        <div className="imgtextbutton-content">
          <h2 className="imgtextbutton-subheadline text-6xl">
            {blok.subheadline}
          </h2>

          {blok.infotext && <p className="pb-3">{blok.infotext}</p>}
          {blok.infotext2 && <p className="pb-3">{blok.infotext2}</p>}
          {blok.infotext3 && <p className="pb-3">{blok.infotext3}</p>}
          {blok.infotext4 && <p className="pb-3">{blok.infotext4}</p>}
          {blok.infotext5 && <p className="pb-3">{blok.infotext5}</p>}
        </div>

        <div>
          {blok.button && (
            <Link href={blok.link} >
              <button>{blok.button}</button>
            </Link>
          )}
          {blok.buttonnewtab && (
            <Link target="_blank" href={blok.linknewtab} >
                <button>{blok.buttonnewtab}</button>
            </Link>
          )}
        </div>
      </div>
    </div>
  </div>
);
export default ImgTextButton;
